import styled from "styled-components"

const ResultContainer = styled.section`
  & > nav {
    background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  }
  & > div:first-of-type > h3 {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const ResultsContainer = styled.div`
  & > div > div:not(:last-child) {
    border-bottom: 5px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export { ResultContainer, ResultsContainer }
